import {CmsCardElement} from '@web-libs/features/cms/domain/cms.types';
import {LocalizedString} from '@web-libs/core/internationalization/internationalization.types';

export function tryGetLocalizedText<T extends CmsCardElement>(element: T,
                                                              key: keyof T): string | undefined {
    const localized = element[`${String(key)}Localized` as keyof T] as LocalizedString | undefined;
    if (localized?.value) {
        return localized.value;
    }
    const elementValue = element[key];
    if (typeof elementValue === 'string') {
        return elementValue;
    }
    return undefined;
}
